(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }

  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;

      // Buscar los productos renderizados en la respuesta AJAX
      var source = container.querySelector(".recommendations-source .product-grid");
      if (!source) { return; }

      var items = source.querySelectorAll(".product-block");
      if (!items.length) { return; }

      var limitA = parseInt(productRecommendationsSection.dataset.limitA) || 4;
      var limitB = parseInt(productRecommendationsSection.dataset.limitB) || 8;

      var gridA = productRecommendationsSection.querySelector(".product-grid-a");
      var gridB = productRecommendationsSection.querySelector(".product-grid-b");

      if (!gridA || !gridB) { return; }

      // Limpiar por si había algo previo
      gridA.innerHTML = "";
      gridB.innerHTML = "";

      // Repartir productos: primeros N a A, siguientes a B
      items.forEach(function(item, index) {
        var clone = item.cloneNode(true);

        if (index < limitA) {
          gridA.appendChild(clone);
        } else if (index < limitA + limitB) {
          gridB.appendChild(clone);
        }
      });

      // Si no hay suficientes para el bloque B, ocultarlo
      if (gridB.children.length === 0) {
        var blockB = productRecommendationsSection.querySelector("#recommendations-b");
        if (blockB) {
          blockB.style.display = "none";
        }
      }
    }
  };
  request.send();
};

// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
